import { Divider } from 'antd'
import AppstreamList from './AppstreamList'
import ServerList from './ServerList'
import React from 'react'

const CourseServers: React.FC<{ showSyncButton: boolean }> = ({ showSyncButton }) => {
  return (
    <>
      <ServerList showSyncButton={showSyncButton} />
      <Divider />
      <AppstreamList />
    </>
  )
}

export default CourseServers
